import { render, staticRenderFns } from "./JourneyConnectionContent.vue?vue&type=template&id=e2e2944a&scoped=true&"
import script from "./JourneyConnectionContent.vue?vue&type=script&lang=js&"
export * from "./JourneyConnectionContent.vue?vue&type=script&lang=js&"
import style0 from "./JourneyConnectionContent.vue?vue&type=style&index=0&id=e2e2944a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2e2944a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("n:\\Projects\\Werk\\MarketingDbNEW\\MarketingDb.Web.Zeiss\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e2e2944a')) {
      api.createRecord('e2e2944a', component.options)
    } else {
      api.reload('e2e2944a', component.options)
    }
    module.hot.accept("./JourneyConnectionContent.vue?vue&type=template&id=e2e2944a&scoped=true&", function () {
      api.rerender('e2e2944a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/JourneyBuilder/Components/Composer/JourneyConnection/GeneralSettings/JourneyConnectionContent.vue"
export default component.exports